import {
  createInventorizationIssue,
  INVENTORIZATION_BLOCK_IDS,
  readInventorizationBlockStatus,
} from '@/features/inventorization/domain/inventorization';
import type { InventorizationContext } from '@/features/inventorization/domain/inventorization-context';
import type { BlockStatus, ValidationIssue } from '@/shared/capture/capture-session';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export function validateInventorizationContext(context: InventorizationContext): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  const blockId = INVENTORIZATION_BLOCK_IDS.context;

  if (!context.locationName.trim()) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'CONTEXT_LOCATION_MISSING',
        translateInventoryText('app.inventory.validation.context.locationRequired', 'Location is required.'),
      ),
    );
  }

  if (!context.buildingName.trim()) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'CONTEXT_BUILDING_MISSING',
        translateInventoryText('app.inventory.validation.context.buildingRequired', 'Building is required.'),
      ),
    );
  }

  if (!context.floorName.trim()) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'CONTEXT_FLOOR_MISSING',
        translateInventoryText('app.inventory.validation.context.floorRequired', 'Floor is required.'),
      ),
    );
  }

  return issues;
}

export function getInventorizationContextBlockStatus(
  context: InventorizationContext,
  hasContextPhoto: boolean,
): BlockStatus {
  return readInventorizationBlockStatus(validateInventorizationContext(context), hasContextPhoto);
}
